import { useContext } from 'react';

import { noop } from '@/utils/noop';

import { FancyRenderingContext } from './FancyRenderingContext';

export function useFancyRendering() {
  const context = useContext(FancyRenderingContext);
  if (context === undefined) {
    return {
      fancyRendering: false,
      setFancyRendering: noop,
      hasContext: false,
      enableMarkdownInTracing: false,
    };
  }
  return { ...context, hasContext: true };
}
